import {ofType} from 'redux-observable';
import {merge, of} from 'rxjs';
import {map, catchError, debounceTime} from 'rxjs/operators';
import {Set} from 'immutable';

import {combineEpics} from 'web-app/util/redux-observable';
import {exhaustMapWithTrailing} from 'web-app/util/rxjs';

import * as API from './api';
import * as Actions from './actions';
import * as Selectors from '../selectors';

const fetchResults = (action$, state$) =>
    action$.pipe(
        ofType(Actions.fetchResults.type, Actions.changeSortBy.type),
        exhaustMapWithTrailing((action: any) => {
            const columnsFromQueryParams = action.payload?.columnsFromQueryParams ?? undefined;
            const query = Selectors.resultsQueryOrDefaultState(state$.value, {columnsFromQueryParams});

            return fetchResultsObservable(query, action.payload.fetchMore);
        }),
    );

const fetchResultsObservable = (query: API.ResultsQuery, fetchMore?: boolean) => {
    return API.filterResults(query).pipe(
        map(response => Actions.fetchResultsSuccess.action(response, fetchMore)),
        catchError(e => of(Actions.fetchResultsFailed.action(e))),
    );
};

const fetchResultsOnChange = (action$, state$) =>
    action$.pipe(
        ofType(Actions.fetchResultsDebounced.type),
        debounceTime(500),
        exhaustMapWithTrailing((action: any) => {
            const columnsFromQueryParams = action.payload?.columnsFromQueryParams ?? Set([]);
            const query = Selectors.resultsQueryOrDefaultState(state$.value, {columnsFromQueryParams});
            return merge(
                fetchResultsObservable({
                    ...query,
                    offset: 0,
                }),
                of(Actions.setOffset.action({offset: 0})),
            );
        }),
    );

export default combineEpics(fetchResults, fetchResultsOnChange);
